<template>
    <section class="user-notifications">
        <el-form ref="form" :model="userProfile">
            <label>Select the Notification types you would like to receive below.</label>

            <ul v-if="_.has(userProfile, 'user_settings.notifications')" class="mt-5 p-0" style="list-style: none">
                <li>
                    <el-checkbox v-model="userProfile.user_settings.notifications.tasks" border label="tasks">Tasks
                    </el-checkbox>

                    <el-checkbox v-model="userProfile.user_settings.notifications['new-lead']" border label="new-lead">
                        Leads
                    </el-checkbox>

                    <el-checkbox v-model="userProfile.user_settings.notifications.system" border label="system">System
                    </el-checkbox>

                    <el-checkbox v-model="userProfile.user_settings.notifications.outbound" border label="outbound">
                        Email Bounces
                    </el-checkbox>

                    <el-checkbox v-model="userProfile.user_settings.notifications.support_ticket" border
                                 label="support_ticket">
                        Support Ticket
                    </el-checkbox>
                </li>
            </ul>
        </el-form>
        <el-button class="mt-3 mb-1" ref="saveUserNotifications" :disabled="saving" type="primary"
                   @click="saveUserNotifications">
            {{ saveText }}
        </el-button>

        <div class="mt-4">
            <profileNotifications></profileNotifications>
        </div>
    </section>
</template>

<script>
import userProfile from "@shared/components/user/userProfile.vue"
import profileNotifications from './profileNotifications.vue';
export default {
    name: "UserNotifications",
    components: {
        profileNotifications
    },
    props: ['token', 'teamId', 'brokerId'],
    data() {
        return {
            tempName: "",
            saving: false,
            saveText: "Save Notification Settings",
        }
    },
    computed: {
        userProfile: {
            get() {
                return this.$store.getters["user/user"]
            },
            set(profile) {
                this.$store.dispatch("user/setUser", profile)
            },
        },
    },
    watch: {
        userProfile: {
            immediate: true,
            deep: true,
            handler(userProfile) {
                if (!_.has(userProfile, "user_settings.notifications")) {
                    let notifications = {
                        tasks: true,
                        "new-lead": true,
                        system: true,
                        outbound: true,
                        support_ticket: true,
                    }
                    this.$set(userProfile.user_settings, "notifications", notifications)
                }
            },
        },
    },
    mounted() {
    },
    updated() {
    },
    activated() {
    },
    methods: {
        saveUserNotifications() {
            
                axios.post("/admin/account/save-user-settings", {
                    id: this.userProfile.id,
                    profile: {
                        personal_access_token: this.userProfile.personal_access_token,
                        token: this.$store.getters.token,
                    },
                    settings: {
                        notifications: this.userProfile.user_settings.notifications
                    },

                })
                .then((response) => {
                    this.tempName = response.data
                    console.warn(this.tempName)
                    this.$notify({
                        title: "Saved!",
                        message: "Your settings were updated.",
                    })
                })
                .catch((err) => {
                    this.$notify({
                        title: "Error!",
                        message: "There was an error while updating your settings. Please contact support.",
                    })
                })
                .finally(() => {
                    this.saving = false
                    this.saveText = "Save Settings"
                })
        },
    },
}
</script>

<style lang="scss" scoped>
.user-notifications {
    padding: 50px;
}
</style>